/*
 * This file was automatically generated. Do not make any changes
 * directly as they may be overwritten.
 *
 * To update this file, run `yarn run generate-api`.
 */
import { apiService } from "assets/scripts/domain/apiService";
/* tslint:disable */
export const CANCEL_SCHEDULED_PAYMENT_URL = "/api/payment/cancel";
export const CREATE_URL = "/api/payment/create";
export const EMAIL_RECIEPT_URL = "/api/payment/emailreceipt";
export const QUICK_CREATE_URL = "/api/payment/quickcreate";
export const RECIEPT_URL = "/api/payment/receipt";
export function cancelScheduledPayment(paymentId) {
    return apiService.post(CANCEL_SCHEDULED_PAYMENT_URL, true, {
        paymentId
    });
}
export function create(model) {
    return apiService.post(CREATE_URL, true, {
        model
    });
}
export function emailReciept(paymentId) {
    return apiService.post(EMAIL_RECIEPT_URL, true, {
        paymentId
    });
}
export function quickCreate(model) {
    return apiService.post(QUICK_CREATE_URL, false, {
        model
    });
}
export function reciept(paymentId) {
    return apiService.post(RECIEPT_URL, true, {
        paymentId
    });
}
/* tslint:enable */ 



// WEBPACK FOOTER //
// ./src/generated/api/payment.ts